const safeSessionStorage = {
  getItem: key => {
    try {
      return sessionStorage.getItem(key);
    } catch (err) {
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      sessionStorage.setItem(key, value);
      // eslint-disable-next-line no-empty
    } catch (err) {}
  },
  removeItem(key) {
    try {
      sessionStorage.removeItem(key);
      // eslint-disable-next-line no-empty
    } catch (err) {}
  }
};
export default safeSessionStorage;